import type { DrawingElement } from 'features/Procedure/state/procedure.type'

export const POINTER_TAP_DISTANCE_PX = 8

export type PointerSession = {
  activePointerId: number | null
  isErasing: boolean
  erasedElementId: string | null
  consumed: boolean
  startX: number
  startY: number
}

export const createPointerSession = (): PointerSession => ({
  activePointerId: null,
  isErasing: false,
  erasedElementId: null,
  consumed: false,
  startX: 0,
  startY: 0,
})

export const beginPointerSession = (
  session: PointerSession,
  {
    pointerId,
    clientX,
    clientY,
    isErasing = false,
    consumed = false,
  }: {
    pointerId: number
    clientX: number
    clientY: number
    isErasing?: boolean
    consumed?: boolean
  },
) => {
  session.activePointerId = pointerId
  session.isErasing = isErasing
  session.consumed = consumed
  session.startX = clientX
  session.startY = clientY
  session.erasedElementId = null

  return session
}

export const resetPointerSession = (session: PointerSession) => {
  session.activePointerId = null
  session.isErasing = false
  session.consumed = false
  session.startX = 0
  session.startY = 0
  session.erasedElementId = null

  return session
}

export const isElementErasable = (element: DrawingElement) => {
  return Boolean(element.id)
}

export const consumeEraseHit = (session: PointerSession, elementIdentity: string) => {
  if (!session.isErasing || session.erasedElementId !== null) {
    return false
  }

  session.erasedElementId = elementIdentity
  session.consumed = true

  return true
}

export const isActivePointerSession = (session: PointerSession, pointerId: number) => {
  return session.activePointerId === pointerId
}

export const isTapGesture = (
  session: PointerSession,
  clientX: number,
  clientY: number,
  threshold = POINTER_TAP_DISTANCE_PX,
) => {
  if (session.activePointerId === null) {
    return false
  }

  return Math.hypot(clientX - session.startX, clientY - session.startY) <= threshold
}
